import globalAxios from '../GlobalAxios';

const fetchProgram = async () => {
  const response = await globalAxios.get('/api/vod/program');
  return response.data;
};

const fetchPlayback = async (lectureId) => {
  const response = await globalAxios.get(`/api/vod/lectures/${lectureId}/playback`);
  return response.data;
};

const saveWatch = async (data) => {
  const response = await globalAxios.post('/api/vod/watch', data, {
    timeout: 8000,
  });
  return response.data;
};

export default {
  fetchProgram,
  fetchPlayback,
  saveWatch,
};
